import {
  SubcategoryAreaFilter,
  listSubcategoryAreas,
} from '@/data/services/subcategoryAreaServices';

export const subcategoryAreaQueries = {
  all: ['subcategory-areas'] as const,

  list: (filters: SubcategoryAreaFilter = {}) => ({
    queryKey: [...subcategoryAreaQueries.all, 'list', { filters }] as const,
    queryFn: () => listSubcategoryAreas(filters),
  }),

  listInfinite: (filters: SubcategoryAreaFilter = {}) => ({
    queryKey: [
      ...subcategoryAreaQueries.list(filters).queryKey,
      'infinite',
    ] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listSubcategoryAreas({ ...filters, pageNumber: ctx.pageParam }),
  }),
};
